import PageContainer from './PageContainer';
import PropTypes from 'prop-types';

const TabPanel = ({ menuItem }) => {
    const Component = menuItem.component;
    return menuItem ? (
        <>
            <div
                className="tabPageContainer w3-animate-right"
                style={{
                    ...(menuItem.selected
                        ? {
                              width: '100%',
                              height: ' calc(100vh - (var(--header-height) -var(--side-menu-tab-height)))',
                              overflow: 'auto',
                              paddingBottom: '2rem',
                          }
                        : { display: 'none' }),
                }}
            >
                <PageContainer
                    menuName={menuItem.menuName}
                    menuId={menuItem.menuId}
                    helpYn={menuItem.helpYn}
                    menuNameListId={menuItem.menuNameListId}
                    menuNameList={menuItem.menuNameList}
                >
                    {Component ? <Component /> : null}
                </PageContainer>
            </div>
        </>
    ) : null;
};

TabPanel.propTypes = {
    menuItem: PropTypes.shape({
        component: PropTypes.object,
        selected: PropTypes.bool,
        menuName: PropTypes.string,
        menuId: PropTypes.string,
        helpYn: PropTypes.string,
        menuNameListId: PropTypes.string,
        menuNameList: PropTypes.string,
    }),
};

export default TabPanel;
